import { usePage } from '@inertiajs/react'
import { t } from '@/shared/lib/i18n'
import type { SharedProps } from '@/shared/types/SharedProps'
import { cn } from '@/shared/lib/utils'

interface AuthFooterProps {
  className?: string
}

const AuthFooter = ({ className }: AuthFooterProps) => {
  const { appInfo } = usePage<SharedProps>().props

  if (!appInfo) {
    return null
  }

  const currentYear = new Date().getFullYear()

  return (
    <footer className={cn('mt-8 space-y-1 text-center text-xs text-muted-foreground', className)}>
      <p>{t('auth.footer.copyright', { year: currentYear })}</p>
      <a
        href={appInfo.releaseNotesUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-block text-sky-700 underline-offset-4 hover:underline"
      >
        {t('auth.footer.releaseLabel', { version: appInfo.version })}
      </a>
    </footer>
  )
}

export { AuthFooter }
